import { formatText, TextRole } from '@pickleballinc/lib/format-text';
import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import { Button } from '@pickleballinc/react-ui';
import clsx from 'clsx';
import { Fragment } from 'react';

interface MyModulesNoResultsProps {
	text?: string;
	illustrationUrl?: string;
	description?: string;
	buttonText?: string;
	buttonLink?: string;
	buttonClasses?: string;
	hideBorder?: boolean;
	cdnUrl: string;
	isReservationsHomePage?: boolean;
	descriptionTextColor?: string;
}

export const MyModulesNoResults = ({
	text,
	description,
	buttonText,
	buttonLink,
	illustrationUrl,
	buttonClasses,
	hideBorder = false,
	cdnUrl,
	isReservationsHomePage = false,
	descriptionTextColor = '#344054'
}: MyModulesNoResultsProps) => {
	const illustrationHeight = isReservationsHomePage ? 120 : 233;
	const illustrationWidth = isReservationsHomePage ? 160 : 320;

	const formattedText = (text ?? 'Nothing Found')
		.split('\n')
		.map((line) => formatText({ text: line, role: TextRole.SectionHeader }))
		.join('\n');

	const formattedDescription = description ? formatText({ text: description, role: TextRole.DescriptiveText }) : undefined;

	const formattedButtonText = buttonText ? formatText({ text: buttonText, role: TextRole.ButtonLabel }) : undefined;

	return (
		<div
			className={clsx(
				'flex flex-col items-center justify-evenly rounded-lg p-4 sm:p-10',
				!hideBorder && 'border',
				!isReservationsHomePage && 'gap-12'
			)}
		>
			<div className={clsx('overflow-hidden rounded-md', isReservationsHomePage ? 'h-[90px] w-[125px]' : 'h-[188px] w-[250px]')}>
				<img
					src={illustrationUrl || getCDNURL(`${cdnUrl}/global/PB-empty-dataset.svg`, illustrationWidth, illustrationHeight)}
					width={illustrationWidth}
					height={illustrationHeight}
					alt={`${formattedText} - Illustration`}
					className={clsx(!isReservationsHomePage && 'mb-10')}
				/>
			</div>

			<div className={clsx('flex flex-col items-center', isReservationsHomePage ? 'gap-2 mt-1' : 'gap-3')}>
				<h3 className="text-xl text-center flex justify-center items-center font-semibold text-[#101828] sm:text-2xl">
					{formattedText.split('\n').map((line, idx) => (
						<Fragment key={`text-line-${line}-${idx}`}>
							{line}
							<br />
						</Fragment>
					))}
				</h3>
				{formattedDescription ? (
					<p className={clsx('text-center text-base font-normal', isReservationsHomePage && 'mb-2', descriptionTextColor)}>
						{formattedDescription}
					</p>
				) : null}
			</div>

			{formattedButtonText ? (
				<a href={buttonLink || ''} className="w-full">
					<Button size="lg" className={clsx('w-full justify-center !text-sm !font-semibold sm:!text-base', buttonClasses)}>
						{formattedButtonText}
					</Button>
				</a>
			) : null}
		</div>
	);
};
